import { Record, Set, Map, List } from 'immutable';

import { getRowByNumber, matchCell, JournalFactory } from '../journal/helper';

export const ReconciliationFactory = new Record({
  selectedEntry: List(),
  searchEntry: JournalFactory(),
  detailsRow: false,
  rowState: null,
  loading: false,
  requestRow: Map(),
  requestPopup: false,
});

export const rowAdapter = (data, rowNumber) =>
  data.mapEntries(([key, value]) => {
    // eslint-disable-next-line no-unused-vars
    const [column, _] = matchCell(key);
    const newCellName = `${column}${rowNumber}`;
    // $FlowFixMe
    return [newCellName, value.set('_cell', newCellName)];
  });

// eslint-disable-next-line max-len
export const selectRowsWithResetCounter = (matrix, rows) =>
  rows.reduce(
    // $FlowFixMe
    (A, row) => {
      // $FlowFixMe
      const rowJE = getRowByNumber(matrix, Set([row]));
      return A.push(rowJE);
    },
    List(),
  );

export function linesReordering(gr, rowsList) {
  return rowsList
    .reduce((a, row, k) => a.set(k, gr.get(row, new Map())), new Map())
    .flatMap((v, k) =>
      v.update((u) => u.mapEntries((e) => [e[1]._col + k, e[1].set('_cell', e[1]._col + k).set('_row', k)])),
    );
}

// eslint-disable-next-line max-len
export function excludeLines(gr, rows, col, status) {
  return rows.filter((f) => !status.includes(gr.getIn([f, col + f, 'cellSet', 'value'])));
}

export function selectFirst3Row(rows) {
  return rows
    .sort((a, b) => a - b)
    .slice(0, 3)
    .toList();
}

// eslint-disable-next-line max-len
export const removeLine = (row, matrix) =>
  matrix.reduce((A, V, K) => {
    // eslint-disable-next-line no-unused-vars
    const [_, cellRow] = matchCell(K);
    return cellRow === row ? A : A.set(K, V);
  }, new Map());

// eslint-disable-next-line max-len
export const actionRestricted = (transactions, total) => {
  if (transactions.length === 1) {
    const transaction = transactions[0];
    return transaction.type === 'Bill' || transaction.type === 'Invoice'
      ? transaction.amount < total
      : transaction.amount !== total;
  }
  const transactionsAmount = transactions.reduce((A, V) => A + V.amount, 0);
  return transactionsAmount !== total;
};

export function sideEffectFlatternJeList(list) {
  return list.reduce((A, V, K) => A.merge(rowAdapter(V, K)), Map());
}

// filters out given column cells
// eslint-disable-next-line max-len
export function sideEffectFilterColumnCellsFactory(column) {
  return (data) => data.filterNot((cell) => cell._col === column);
}

export function sideEffectMakeCellsReadOnly(data) {
  // $FlowFixMelook at RecordOf definition in runtime.
  return data.map((cell) => cell.set('readonly', true));
}

export function sideEffectRemoveCellStyle(data) {
  // $FlowFixMe look at RecordOf definition in runtime.
  return data.map((cell) => cell.set('style', Map()));
}
